export default {
  heading: {
    widgetName: "Customisable-Pack",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "These customisable Value Packs are delivered for FREE with no min. spend!",
    headlineType: 'h2',
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer Value Pack`,
      eventLabelCardClick: `Grocer Value Pack | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer Value Pack | headline | {{headline}}`,
      eventLabelView: `Grocer Value Pack`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/small_fruit_pack.jpg",
      title: "Fruit Value Pack (Small)",
      subtitle: "Select up to five (5) choices of delicious fruits.",
      star: "",
      originalprice: "53.40",
      price: "24",
      cta: "Shop Now",
      url: "https://www.airasia.com/grocer/my/en/combo/airasia-value-pack-fruit/fruit-value-pack-small",
      currencyCode: "MYR",
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/Large_fruit_pack.jpg",
      title: "Fruit Value Pack (Large)",
      subtitle: "Select up to seven (7) choices of delicious fruits.",
      star: "",
      originalprice: "84.30",
      price: "55",
      cta: "Shop Now",
      url: "https://www.airasia.com/grocer/my/en/combo/airasia-value-pack-fruit/fruit-value-pack-large",
      currencyCode: "MYR",
    },
  ],
}
